import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

import { EstimateSubmittedV1DataSchema } from "./estimate-review-shared";

const InsuranceRevisionElectiveEstimateSubmittedDataSchema = z.discriminatedUnion("version", [
  EstimateSubmittedV1DataSchema,
]);

export const InsuranceRevisionElectiveEstimateSubmittedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSURANCE_REVISION_ELECTIVE_ESTIMATE_SUBMITTED),
  data: InsuranceRevisionElectiveEstimateSubmittedDataSchema,
});
